import React from 'react';
import "../../dashboard/components/genomics-dashboard/components/results/components/query-applied-filters/query-filters.css";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FieldRendering from "../../dashboard/components/genomics-dashboard/components/results/components/query-applied-filters/FieldRendering";
import { query_difference } from "../../dashboard/components/genomics-dashboard/components/results/components/query-applied-filters/query_difference";
import { default_query } from "../../../services/api/genomics_query_samples/query_sample";
import MappedText from '../../study-page/create-study/analysis-page/components/clinical-info/mapText';

export default function QueryFilters_View(props) {
  let { filtersObj } = props;


  const getFilterList = () => {
    if (!filtersObj) {
      return (
        <div>
          <Typography variant="subtitle2">None</Typography>
        </div>
      );
    }

 
    let query_1 = default_query;
    let query_2 = filtersObj;
    let list_of_filters = query_difference(query_1, query_2);

    if (!list_of_filters) {
      return (
        <div>
          <Typography variant="subtitle2">None</Typography>
        </div>
      );
    }

  
    delete list_of_filters["size"];

  
    if ("svn" in list_of_filters) {
      delete Object.assign(list_of_filters, { snv: list_of_filters["svn"] })["svn"];
    }

 
    if (typeof list_of_filters !== "object") {
      return (
        <div>
          <Typography variant="subtitle2">None</Typography>
        </div>
      );
    }


    const keys = Object.keys(list_of_filters);
    let filters = keys.map((d) => {
      let val = list_of_filters[d];

      if (!val || typeof val !== "object") {
        return null; 
      }
      return FieldRendering(list_of_filters, d, filtersObj.extra); 
    }).filter((s) => s !== null);

    if (filters.length > 0) {
      return <Box m={1}>{filters}</Box>;
    } else {
      return (
        <div>
          <Typography variant="subtitle2">None</Typography>
        </div>
      );
    }
  };

  let currentQuery = filtersObj;

  if (currentQuery !== undefined) {
    return (
      <Box p={1}>
        <Typography
          variant={"body1"}
          style={{ color: "#4575B4", fontWeight: "bold" }}
        >
          <MappedText text="Applied filters:"/>
        </Typography>
        <div>
          {getFilterList()}
        </div>
      </Box>
    );
  } else {
    return (
      <Box p={2}>
        <Typography
          variant={"h6"}
          style={{ color: "#4575B4", fontWeight: "bold" }}
        >
          <MappedText text="No filters found"/>
        </Typography>
      </Box>
    );
  }
}
